import { Component, inject, Input, OnInit } from '@angular/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../../manager/edro-network-manager';
import { SlideModalController } from '../../../../../../../slide-modal.service';
import {
  Pool,
  PoolAdditionalData,
} from '../../../../../../../../apis/pool.api';
import { IProduct } from '../../../../../IProduct';
import { getPoolMasterClass } from '../../../../../../ECoSystemsHelper';
import { P00030 } from '../../../../P00030';
import { P00032 } from '../../../../P00032';
import { P0003600EnSavoirPlusComponent } from '../../../../P0003600/Filtration/enSavoirPlus/p0003600-en-savoir-plus/p0003600-en-savoir-plus.component';
import { FunctionParametersSettingsClockScreenComponent } from '../../../../../../../../components/ecosystems/function-parameters-settings-clock-screen/function-parameters-settings-clock-screen.component';
import { FunctionParametersSettingClockWeekScreenComponent } from '../../../../../../../../components/ecosystems/function-parameters-setting-clock-week-screen/function-parameters-setting-clock-week-screen.component';
import { P00039DataRxTxIndex } from '../../../../P00039Sync';
import { HeaderConfigurationComponent } from '../../../../../../../../components/ecosystems/header-configuration/header-configuration.component';
import { IonButton, IonContent } from '@ionic/angular/standalone';
import { LabelConfigurationComponent } from '../../../../../../../../components/ecosystems/label-configuration/label-configuration.component';
import { LabelDescriptionComponent } from '../../../../../../../../components/ecosystems/label-description/label-description.component';
import { LargedLinkComponent } from '../../../../../../../../components/ecosystems/larged-link/larged-link.component';
import { MinuterieLabelComponent } from '../../../../../../../../components/ecosystems/minuterie-label/minuterie-label.component';
import { TranslatePipe } from '@ngx-translate/core';
import { TwoChoicesControlComponent } from '../../../../../../../../components/ecosystems/two-choices-control/two-choices-control.component';

@Component({
  selector: 'app-p00043-pac-mise-en-oeuvre-horloge',
  templateUrl: './p00043-pac-mise-en-oeuvre-horloge.component.html',
  styleUrls: ['./p00043-pac-mise-en-oeuvre-horloge.component.scss'],
  imports: [
    HeaderConfigurationComponent,
    IonButton,
    IonContent,
    LabelConfigurationComponent,
    LabelDescriptionComponent,
    LargedLinkComponent,
    MinuterieLabelComponent,
    TranslatePipe,
    TwoChoicesControlComponent,
  ],
})
export class P00043PacMiseEnOeuvreHorlogeComponent implements OnInit {
  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);
  private slideModalService: SlideModalController =
    inject(SlideModalController);
  @Input() prev: () => void = () => {};
  @Input() next: (
    actionStack: DeviceActionStackService,
    poolAdditionalData: PoolAdditionalData,
  ) => void = () => {};

  @Input() productClass: IProduct | null = null;

  @Input() poolAdditionalData: PoolAdditionalData | null = null;

  @Input() actionStackParam: any | null = null;
  actionStack: DeviceActionStackService | null = null;

  @Input() pool: Pool | null = null;

  constructor() {}

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      this.actionStackParam,
    );
  }

  async goToFunctionParametersSettingsClockScreen() {
    const modal = await this.slideModalService.create({
      component: FunctionParametersSettingsClockScreenComponent,
      componentProps: {
        value: this.actionStack!.getValue('paPHorlogePicotJour'),
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      const hj = data.value;

      this.actionStack!.editValue(
        P00039DataRxTxIndex.PAC_Parametrage,
        'paPHorlogePicotJour',
        hj,
        null,
      );
    }
  }

  async goToFunctionParametersSettingClockWeekScreen() {
    const modal = await this.slideModalService.create({
      component: FunctionParametersSettingClockWeekScreenComponent,
      componentProps: {
        value: this.actionStack!.getValue('paPHorlogePicotSemaine'),
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      const hj = data.value;
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PAC_Parametrage,
        'paPHorlogePicotSemaine',
        hj,
        null,
      );
    }
  }

  onSubmit() {
    this.next(this.actionStack!, this.poolAdditionalData!);
  }

  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
}
